"use client";

import { Check, Copy, ShareNetwork, TelegramLogo, WhatsappLogo, XLogo, type AppIcon } from "@repo/ui/components/icons";
import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";
import { useEffect, useState } from "react";

// Share the post: the phone's own share sheet where the browser has one (the
// app-like path), otherwise Telegram / WhatsApp / X and copy-link. The URL is
// read at click time, so it is whatever address the reader is on.
export function ShareButtons({ title, className }: { title: string; className?: string }) {
  const [canNativeShare, setCanNativeShare] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setCanNativeShare(typeof navigator.share === "function");
  }, []);

  const url = () => window.location.href.split("#")[0]!;
  const open = (href: string) => window.open(href, "_blank", "noopener,noreferrer");

  const targets: { label: string; icon: AppIcon; onClick: () => void }[] = [
    {
      label: "تلگرام",
      icon: TelegramLogo,
      onClick: () => open(`https://t.me/share/url?url=${encodeURIComponent(url())}&text=${encodeURIComponent(title)}`),
    },
    {
      label: "واتس‌اپ",
      icon: WhatsappLogo,
      onClick: () => open(`https://wa.me/?text=${encodeURIComponent(`${title}\n${url()}`)}`),
    },
    {
      label: "ایکس",
      icon: XLogo,
      onClick: () => open(`https://x.com/intent/post?url=${encodeURIComponent(url())}&text=${encodeURIComponent(title)}`),
    },
    {
      label: copied ? "کپی شد" : "کپی لینک",
      icon: copied ? Check : Copy,
      onClick: () => {
        void navigator.clipboard?.writeText(url()).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        });
      },
    },
  ];

  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      {canNativeShare ? (
        <Button size="pill" onClick={() => void navigator.share({ title, url: url() }).catch(() => {})}>
          <ShareNetwork />
          اشتراک‌گذاری
        </Button>
      ) : null}
      {targets.map(({ label, icon: Icon, onClick }) => (
        <button
          key={label}
          type="button"
          onClick={onClick}
          aria-label={label}
          title={label}
          className="bg-muted hover:bg-border flex h-9 w-9 items-center justify-center rounded-full transition-colors"
        >
          <Icon size={16} />
        </button>
      ))}
    </div>
  );
}
